import React from 'react';
import styles from '../correas_bar/correas_bar.module.scss';
import Perfil from './src/perfil.png';
import Link from '../../components/Link/link.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import catalogoPdf from './src/catalogo-laguspastelaria.pdf';
import CatalogIcon from '../../icons/catalogIcon.tsx';

const Correas_bar: React.FC = () => {

    return (
        <div className={styles.correas_bar}>
            <div className={styles["body-thunder"]}>
                <div style={{ height: "200px" }} className={styles["background-thunder"]}></div>
                <div className={`${styles["container-thunder"]}`} >
                    <img
                        className={styles["img-perfil"]}
                        src={Perfil}
                        alt="Profile Picture"
                    />
                    <h1 className="mb-0">CORREA'S BAR</h1>
                    <p className="mb-3">Acesse nossos links abaixo &nbsp;↓</p>
                    <div className={styles.links}>
                        <Link
                            href="https://www.instagram.com/correas_bar?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                            title="Instagram"
                            icon={<InstagramIcon color="#ffffff" height="32" />}
                            backgroundColor="#EE8E3B"
                            backgroundColorHover="#d67a2b"
                            colorText="#ffffff"
                        />
                        <Link
                            href="https://wa.me/5517992287107"
                            title="Whatsapp"
                            icon={<WhatsappIcon color="#ffffff" height="40" />}
                            backgroundColor="#EE8E3B"
                            backgroundColorHover="#d67a2b"
                            colorText="#ffffff"
                        />
                        <Link
                            href="https://www.pinktech.com.br/menu/correas_bar"
                            title="Cardápio"
                            icon={<CatalogIcon color="#ffffff" height="35" />}
                            backgroundColor="#EE8E3B"
                            backgroundColorHover="#d67a2b"
                            colorText="#ffffff"
                        />
                        <Link
                            href="https://maps.app.goo.gl/H2ycJ6DLPD3YSTKR8"
                            title="Localização"
                            icon={<MapsIcon color="#ffffff" height="40" />}
                            backgroundColor="#EE8E3B"
                            backgroundColorHover="#d67a2b"
                            colorText="#ffffff"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Correas_bar;
